import React from 'react';
import N3RVouslogo from './../../../images/nervouslogo.png'
import './PlanDetails.css'
import { Cloudinary } from '@cloudinary/url-gen';
import { auto } from '@cloudinary/url-gen/actions/resize';
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity';
import { AdvancedImage } from '@cloudinary/react';

function PlanDetails() {
  const cld = new Cloudinary({ cloud: { cloudName: 'ddvootytq' } })
  return (
    <div className="PlanDetails" >
        <div style={{ 
                      backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/jehcqw3jjsnafb3aqj0u")`, 
                      height:'51.25em',
                      width:'100%',
                      backgroundSize:'cover'
                    }}>
            <img className='PlanBoxLogo' src={N3RVouslogo} alt="Red 4 sided star"/>

            <div className='PlanBoxName'>N3RVous</div>

            <div className='PlanBoxTitle'>Turn your music into your career with us</div>

            <div className='PlanBoxDesc'>When you move up to the ranks of N3RVE + you’ll keep 100%<br/>
             of your earnings, release as much music as you want on top<br/>
              platforms, get exposure with iconic brand deals, and more.</div>

            <div style={{display:'flex',flexDirection:'row'}}>
              <div className=''>JOIN FOR FREE</div>
              <div>COMPARE ALL PLANS</div>
            </div>
        </div>
    </div>
  );
}

export default PlanDetails;